import { decimalNumberFormatter } from './formatters/decimal-number';

export function isDefined(val: unknown) {
  return !(val === undefined || val === null);
}

export function getValidNumber(val: unknown): number {
  return isDefined(val) && !isNaN(+val) ? +val : null;
}

export function toFixedDecimals(value: number, decimals: number): number {
  if (!isDefined(value) || !isDefined(decimals)) {
    return null;
  }
  const x = (value.toString() + '.0').split('.');
  return Number(
    decimalNumberFormatter(
      parseFloat(x[0] + '.' + x[1].substring(0, decimals)),
      decimals
    )
  );
}
